import { render, staticRenderFns } from "./TemplatesTable.vue?vue&type=template&id=71437ba4&"
import script from "./TemplatesTable.vue?vue&type=script&lang=ts&"
export * from "./TemplatesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports